import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { Loader } from "src/components/atoms/Loader";
import { CardItem } from "src/components/CommonCard/CardItem";
import { useCurrentRemittanceInfo } from "../hooks/useCurrentRemittanceInfo";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionHeader: {
      background: "#f0f0f0",
      padding: "8px 16px",
      borderRadius: "4px 4px 0 0",
      marginBottom: "0px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #e0e0e0",
      borderBottom: "none"
    },
    sectionHeaderText: {
      fontWeight: "bold",
      fontSize: "14px",
      color: "#333",
    },
    sectionContent: {
      border: "1px solid #e0e0e0",
      padding: "16px",
      marginBottom: "20px",
      borderRadius: "0 0 4px 4px",
    },
    remitInfoContent: {
      border: "1px solid #e0e0e0",
      borderRadius: "4px",
      overflow: "hidden",
    },
    remitTypeRow: {
      padding: "10px 16px",
      borderBottom: "1px solid #e0e0e0",
    },
    remitDetailsGrid: {
      padding: "5px 16px",
    },
    maskedValue: {
      fontFamily:
        'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      letterSpacing: 0,
      fontSize: 13,
      display: "inline-flex",
      alignItems: "center",
    },
    
  })
);

export const CurrentRemittanceInfo = () => {
  const classes = useStyles();
  const { loader, currentRemittanceData } = useCurrentRemittanceInfo();

  const renderMaskedValue = (value: string) => {
    if (!value) return null;

    // Find the end of leading asterisks without using regex to avoid ReDoS and satisfy Sonar
    let asteriskCount = 0;
    while (asteriskCount < value.length && value.charAt(asteriskCount) === "*") {
      asteriskCount++;
    }

    if (asteriskCount > 0) {
      return (
        <span className={classes.maskedValue}>{value}</span>
      );
    }
    return <span className={classes.maskedValue}>{value}</span>;
  };

  return (
    <>
      <Loader open={loader} />
      <Box className={classes.sectionHeader}>
        <Typography className={classes.sectionHeaderText}>Current Payment Remittance Info</Typography>
      </Box>
      <Box className={classes.sectionContent}>
        {!currentRemittanceData?.remitType ? (
          !loader && <Typography variant="body2" color="textSecondary">
            No current remittance information available. Please update below.
          </Typography>
        ) : (
          <Box className={classes.remitInfoContent}>
            <Grid container direction="row">
              <Grid item container direction="row">
                <Box className={classes.remitTypeRow} width="100%">
                  <CardItem field="Remittance Type" value={currentRemittanceData.remitType || "Check"} />
                </Box>
                {currentRemittanceData.remitType === "ACH" ? (
                  <Grid item xs={12} className={classes.remitDetailsGrid}>
                    <Grid container direction="row" spacing={1}>
                      <Grid item xs={12}>
                        <CardItem field="ACH Email" value={currentRemittanceData.eftEmail} />
                      </Grid>
                      <Grid item xs={12}>
                        <CardItem field="ACH Bank" value={currentRemittanceData.eftBank} />
                      </Grid>
                      <Grid item xs={12}>
                        <CardItem
                          field="ACH Routing"
                          value={renderMaskedValue(currentRemittanceData.eftBanknum)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <CardItem
                          field="ACH Acct Number"
                          value={renderMaskedValue(currentRemittanceData.eftAcctnum)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item xs={12} className={classes.remitDetailsGrid}>
                    <Grid container direction="row" spacing={1}>
                      <CardItem field="Company" value={currentRemittanceData.checkCompany} />
                      <CardItem field="DBA" value={currentRemittanceData.checkDBA} />
                      <CardItem field="Phone Number" value={currentRemittanceData.checkPhone} />
                      <CardItem field="Contact" value={currentRemittanceData.checkContact} />
                      <CardItem field="Address 1" value={currentRemittanceData.checkAddress1} />
                      <CardItem field="Address 2" value={currentRemittanceData.checkAddress2} />
                      <CardItem field="City" value={currentRemittanceData.checkCity} />
                      <CardItem field="State" value={currentRemittanceData.checkState} />
                      <CardItem field="Zip" value={currentRemittanceData.checkZip} />
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </>
  );
};
